import script from "./DataCenter.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataCenter.vue?vue&type=script&lang=ts&setup=true"

import "./DataCenter.vue?vue&type=style&index=0&id=6a51c780&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a51c780"]])

export default __exports__